import React from "react";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ArcElement,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ArcElement
);

const DistributionGraph = (props) => {

  return (
    <div style={{ width: "190px" }}>
      <Pie
        options={{
          responsive: true,
          plugins: {
            legend: {
              labels: {
                boxWidth: 10,
                boxHeight: 12,
                borderRadius: 5,
                borderColor: "none",
                borderWidth: 0,
                usePointStyle: true,
                margin: 10,
                padding: 10,
                color: "#1974CE",

                font: {
                  size: 12,
                  weight: "500",
                },
              },

              display: "block",
              position: "top",
            },
          },
          elements: {
            arc: {
              borderWidth: 0,
              borderColor: "none",
            },
          },
        }}
        data={{
          labels: ["Low", "Average", "High"],
          datasets: [
            {
              label: "Engagement Distribution",
              data: props?.engagementDistribution,
              backgroundColor: ["#8dbbe9c6", "#328DE6", "#047ef7"],
              hoverOffset: 3,
            },
          ],
        }}
      />

      {!props?.engagementDistribution && (
        <div
          style={{
            position: "relative",
            bottom: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="empty-circle"></div>
        </div>
      )}
    </div>
  );
};

export default DistributionGraph;
